import { render } from "./MobileNav.vue?vue&type=template&id=15f36a68&scoped=true&ts=true"
import script from "./MobileNav.vue?vue&type=script&lang=ts"
export * from "./MobileNav.vue?vue&type=script&lang=ts"

import "./MobileNav.vue?vue&type=style&index=0&id=15f36a68&lang=scss&scoped=true"

import exportComponent from "D:\\Karol\\Documents\\Github\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f36a68"]])

export default __exports__